import { lang } from '@umu/ukit-lang';
/**
 * @description 笔记图片分享
 * @author wayou
 * @date
 */

import React, { Component } from 'react';

import './notePicShare.scss';

import { components } from 'common';
const { Loading, If, Emg } = components;
import * as ImageUtil from '@umu/umu-image-handle';
import umuWebview from '@umu/umu-webview';
import { $window } from '@umu/umu-dom';
import { getSharePicUrl } from '@umu/umu-api';
import { CommentParentType } from '@umu/umu-types';

let requestStatusTimoutId: number = 0;

interface IProps {
    parentType: CommentParentType;
    commentId: string;
    sharePicUrl?: string;
}
interface IState {
    generating: boolean;
    sharePicUrl: string;
}

class NotePicShare extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            generating: !props.sharePicUrl,
            sharePicUrl: props.sharePicUrl || '',
        };

        this.requestNotePic = this.requestNotePic.bind(this);
    }

    public componentWillUnmount() {
        if (requestStatusTimoutId) {
            clearTimeout(requestStatusTimoutId);
        }
    }

    public componentDidMount() {
        // 如果没有图片地址则请求生成图片并轮询生成状态
        const props = this.props;
        if (!props.sharePicUrl) {
            this.requestNotePic();
        }
    }

    public requestNotePic() {
        const self = this;
        getSharePicUrl({
            comment_id: Number(this.props.commentId),
            parent_type: this.props.parentType,
        }).then((res: any) => {
            if (!res.data) {
                return;
            }
            const status = res.data.status;
            const sharePicUrl = res.data.share_pic_url;
            switch (status) {
                case 0:
                    // 正在生成, 轮询
                    requestStatusTimoutId = $window.setTimeout(() => {
                        self.requestNotePic();
                    }, 1000);
                    break;
                case 1:
                    // 生成成功，展示图片
                    self.setState({
                        generating: false,
                        sharePicUrl,
                    });
                    break;
                default:
                    break;
            }
        });
    }

    public render() {
        let shareTip = lang('长按保存图片，分享到朋友圈或发送给朋友');
        if (umuWebview && umuWebview.UA_INFO.isUMUWebview) {
            shareTip = lang('保存笔记图片，分享到朋友圈或发送给朋友');
        }
        return (
            <div className="note-pic-share">
                <p className="note-pic-share-tip">{shareTip}</p>
                <div className="note-pic-share-frame">
                    <If condition={this.state.generating}>
                        <div className="pic-generating">
                            <Loading />
                            <p>{lang('笔记图片生成中...')}</p>
                        </div>
                    </If>
                    <If condition={!this.state.generating}>
                        <Emg src={ImageUtil.appendWidth(this.state.sharePicUrl, 600)} />
                    </If>
                </div>
            </div>
        );
    }
}

export default NotePicShare;
